import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { SlideFrame } from '../SlideFrame';
import { solventumInputs, snakkerInputs } from '../../data/deckContent';
type InputItem = {
  text: string;
  note?: string;
};
export function StartSlide() {
  return <SlideFrame eyebrow="The start" index={12} chapter="tactics" data-id="element-205" data-mp="fi00hdvwy1tq">
      <div data-id="element-206" data-mp="alsrfc880a7k">
        <h2 className="text-[clamp(22px,3.1vw,55px)] font-semibold leading-[1.06] tracking-tight text-white" data-id="element-207" data-mp="am2nnhjuzdlp">
          What do we need to make this happen?
        </h2>

        <div className="mt-[3.2vh] grid grid-cols-2 gap-[3vw]" data-id="element-208" data-mp="3f0slz38o6gyd">
          <Column title="Solventum" items={solventumInputs} accent numbered offset={0} data-id="element-209" data-mp="3sqmcrr3qjbaq" />
          <Column title="Snakker" items={snakkerInputs} offset={5} data-id="element-210" data-mp="3nyuus4ynadw7" />
        </div>

        <p className="mt-[3.4vh] text-[clamp(13px,1.65vw,31px)] font-light leading-tight text-white" data-id="element-211" data-mp="3090iboi8mrch">
          Start with a few products.{' '}
          <span className="font-medium text-[color:var(--sv-green)]" data-id="element-212" data-mp="3tx3ieud091om">
            Build the platform as we learn.
          </span>
        </p>
      </div>
    </SlideFrame>;
}
type ColumnProps = {
  title: string;
  items: InputItem[];
  accent?: boolean;
  numbered?: boolean;
  offset: number;
};
function Column({
  title,
  items,
  accent = false,
  numbered = false,
  offset
}: ColumnProps) {
  const reduced = useReducedMotion();
  return <div data-id="element-213" data-mp="3az9eguqqhgd3">
      <p className={`border-b pb-[1vh] text-[clamp(9px,0.9vw,17px)] font-semibold uppercase tracking-[0.3em] ${accent ? 'border-[color:var(--sv-green)]/45 text-[color:var(--sv-green)]' : 'border-white/15 text-white/70'}`} data-id="element-214" data-mp="3azj4gibs3nis">
        {title}
      </p>

      <ul className="mt-[1.6vh] space-y-[1.1vh]" data-id="element-215" data-mp="3ozk6i13s50zu">
        {items.map((item, i) => <motion.li key={item.text} initial={reduced ? false : {
        opacity: 0,
        y: 8
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        delay: 0.04 * (offset + i),
        ease: [0.23, 1, 0.32, 1]
      }} className="flex gap-[0.8vw]" data-id="element-216" data-mp="105emxq578dti" data-mpi={i}>
            {numbered ? <span className="w-[1.2vw] shrink-0 text-[clamp(9px,0.85vw,16px)] font-medium tabular-nums text-white/30" data-id="element-217" data-mp="3a9c83oasdl5l">
                {i + 1}
              </span> : <span aria-hidden="true" className="mt-[0.9vh] h-[0.35vh] w-[0.7vw] shrink-0 bg-[color:var(--sv-green)]/60" data-id="element-218" data-mp="2hjx1daq5mefh" />}
            <span data-id="element-219" data-mp="2ra86v1phkvoh">
              <span className="block text-[clamp(10px,1.05vw,20px)] font-light leading-snug text-white/85" data-id="element-220" data-mp="2rarjc2wdarv4">
                {item.text}
              </span>
              {item.note ? <span className="mt-[0.3vh] block text-[clamp(8px,0.78vw,14px)] font-light leading-snug text-white/35" data-id="element-221" data-mp="1ytnkcuppki3q">
                  {item.note}
                </span> : null}
            </span>
          </motion.li>)}
      </ul>
    </div>;
}